<!-- 报表配置 -->
<template>
	<div class="basis-page-cls">
		<section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="queryInfo" @filterSearch="getList" />
		</section>
		<section class="basis-cls_table">
			<div class="header">
				<span class="title el-icon-document"> 报表列表</span>
				<div class="btns">
					<el-button type="primary" size="small" @click="showAddReport()">新增</el-button>
				</div>
			</div>
			<div class="table">
				<table-pagination pagination :data="list" :column="column" :total="total" :page.sync="queryInfo.pageNum" :limit.sync="queryInfo.pageSize" @pagination="getList" />
			</div>
		</section>
		<manageReport ref="manageReport" @requestList="getList" />
		<conditionConfig ref="conditionConfig" />
	</div>
</template>
<script>
import manageReport from "./components/manageReport";
import conditionConfig from "./components/conditionConfig";
import { mapGetters } from 'vuex';

export default {
	components: {
		manageReport,
		conditionConfig
	},
	data() {
		return {
			// 列表数据
			column: [{
					label: '报表id',
					prop: 'reportId',
					minWidth: 120
				},
				{ label: '报表状态', prop: 'reportState', minWidth: 100,
					render: (h, scope) => {
						return (
							<span>{scope.row.reportState == "1"?'正常':"锁定"}</span>
						)
					}
				},
				{ label: '报表名称', prop: 'reportName', minWidth: 150 },
				{
					label: '条件配置',
					prop: 'reportType',
					width: 120,
					render: (h, scope) => {
						return <el-button type="text" onClick={()=>this.conditionConfig(scope.row)}>条件配置</el-button>
					}
				},
				{
					label: '操作',
					prop: 'createTime',
					minWidth: 180,
					render: (h, scope) => {
						return (
							<div>
								<el-button type="text" onClick={()=>this.showReportDetail(scope.row)}>详情</el-button>
								<el-button type="text" onClick={()=>this.showUpdateDetail(scope.row)}>修改</el-button>
								<el-button type="text" onClick={()=>this.deleteReport(scope.row)}>删除</el-button>
								<el-button type="text" onClick={()=>this.executeReport(scope.row)}>预览</el-button>
								<el-button type="text" onClick={()=>this.addToMenu(scope.row)}>添加到菜单</el-button>
							</div>
						)
					}
				},
			],
			// ------------------------------------------------------------
			// 表头数据
			filterHeader: [{
					label: '报表id',
					model: 'reportId',
					type: 'input',
					default: '',
					placeholder: '请输入报表id'
				},
				{
					label: '报表名称',
					model: 'reportName',
					type: 'input',
					default: '',
					placeholder: '请输入报表名称'
				},
				{
					label: '报表状态',
					model: 'reportState',
					type: 'select',
					default: "",
					list: [{
						id: 1,
						name: "启用"
					}, {
						id: 0,
						name: "禁用"
					}],
					placeholder: '请选择报表状态'
				}
			],
			reportId: "",
			queryInfo: {
				pageNum: 1,
				pageSize: 10,
				prantBrand: '',
				reportId: "",
				reportName: "",
				reportState: ""
			},
			total: 0,
			// --------------------------------
			list: []
		}
	},
	computed: {
		...mapGetters([
			'userInfo',
			'subBrandList',
			'channelList',
			'permission_menus'
		])
	},
	watch: {},
	creat() {

	},
	mounted() {
		this.queryInfo.prantBrand = this.userInfo.brandIdentify
		this.getList();
	},
	methods: {
		conditionConfig(reportData) {
			this.$refs.conditionConfig.open(reportData);
		},
		showAddReport() {
			this.$refs.manageReport.showAddReport();
		},
		showReportDetail(reportData) {
			this.$refs.manageReport.showReportDetail(reportData);
		},
		showUpdateDetail(reportData) {
			this.$refs.manageReport.showUpdateDetail(reportData);
		},
		deleteReport(reportData) {
			this.$confirm(`是否要删除报表配置"${reportData.reportName}"`,'提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$api.reportDefinitionDefinitionDeleteJson(reportData).then((res) => {
					this.$message({
						type: 'success',
						message: '操作成功!'
					})
					this.getList();
				})
			})
		},
		// 跳转到详情预览页
		executeReport(row) {
			this.$router.push({
				name: `report`,
				params: {
					reportId: row.reportId,
					reportName: row.reportName
				}
			})
			// console.log(row.reportId);
		},
		// 添加报表到报表管理菜单下
		addToMenu(row) {
			let permission_menus = this.permission_menus;
			let reportMenuItem = permission_menus.find(item=>{
				return item.menuUrl == "/report";
			})
			let parentMenuId = reportMenuItem.menuId;
            this.$api.getMenuSaves({
            	createBy: "",
				createTime: "",
				description: "",
				isOpen: "0",
				menuIco: "",
				menuId: "",
				menuName: row.reportName,
				menuType: "menu",
				menuUrl: "/report/report_view/" + row.reportId,
				mustVerifys: "",
				nodes: [],
				orderNumber: "",
				parentMenuId: parentMenuId,
				parentMenuName: "报表管理",
				state: "0",
				viewUrl: ""
            }).then(res => {
                if (res.errcode == 0) {
                    this.$message.success('添加成功!')
                }
            }).catch(res => {
            })
        },
		setTableData(list) {
			this.list = list;
		},
		getList() {
			this.$api.reportDefinitionReportDefinitionJson({
				pageNum: this.queryInfo.pageNum,
				pageSize: this.queryInfo.pageSize,
				orderBy: "",
				data:{
					reportId: this.queryInfo.reportId,
					reportName: this.queryInfo.reportName,
					reportState: this.queryInfo.reportState
				}
			}).then(res => {
				if(res.errcode != 0) return;
				this.total = res.total;
				this.setTableData(res.list)
			})
		}
	},
}
</script>
<style lang="scss" scoped>
</style>